import React, { useEffect, useState } from "react";
import { Table, Typography, Button, Space, Popconfirm, message } from "antd";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

function ManageProject() {

const [projects, setProjects] = useState([]);
const navigate = useNavigate();

useEffect(() => {

const token = localStorage.getItem("access-token");

fetch("https://rhrmapi.up2dateinc.com/api/projects", {
headers: {
Authorization: `Bearer ${token}`
}
})
.then(res => res.json())
.then(data => {
if (Array.isArray(data)) {
setProjects(data);
} else {
setProjects([]);
}
})
.catch(err => {
console.log(err);
setProjects([]);
});

}, []);

const deleteProject = async (id) => {

try {

const token = localStorage.getItem("access-token");

await fetch(`https://rhrmapi.up2dateinc.com/api/projects/${id}`, {
method: "DELETE",
headers: {
Authorization: `Bearer ${token}`
}
});

setProjects(projects.filter((item) => item._id !== id));

message.success("Project Deleted Successfully");

} catch (error) {

message.error("Failed to delete project");

}

};

const columns = [
{
title: "SL No",
render: (_, __, index) => index + 1,
},
{
title: "Project Name",
dataIndex: "projectName",
},
{
title: "Project Lead",
dataIndex: "projectLead",
},
{
title: "Approximate Tasks",
dataIndex: "tasks",
},
{
title: "Project Duration",
dataIndex: "duration",
render: (text) => `${text} days`,
},
{
title: "Status",
dataIndex: "status",
},
{
title: "Action",
render: (_, record) => (
<Space>

<Button
type="link"
onClick={() => navigate(`/admin/backlogs/${record._id}`)}
>
Backlogs
</Button>

<Button
type="link"
onClick={() => navigate(`/admin/sprints/${record._id}`)}
>
Sprints
</Button>

{/* ✅ NEW RISK BUTTON */}
<Button
type="link"
onClick={() => navigate(`/admin/risk/${record._id}`)}
>
Risk
</Button>

<Button
type="link"
onClick={() =>
navigate(`/admin/update-project/${record._id}`)
}
>
Update
</Button>

<Popconfirm
title="Delete this project?"
disabled
onClick={() => message.info("Delete disabled. Requires admin approval")}

>
<Button type="link" danger>
Delete
</Button>
</Popconfirm>

</Space>
),
},
];

return (
<div>

<Title level={3}>Manage Projects</Title>

<Table
rowKey="_id"
columns={columns}
dataSource={Array.isArray(projects) ? projects : []}
pagination={{ pageSize: 5 }}
/>

</div>
);
}

export default ManageProject;